<template>
  <select v-model="pageSize" class="bg-primary hover:bg-primary/80 border-primary rounded-md px-2 text-white">
    <option class="bg-primary/80" :value="5">5</option>
    <option class="bg-primary/80" :value="10">10</option>
    <option class="bg-primary/80" :value="20">20</option>
    <option class="bg-primary/80" :value="50">50</option>
  </select>
</template>

<script setup lang="ts">
const pageSize = defineModel<number>({ required: true });
</script>
